// src/i18n/en/errorDefinitions.ts

/**
 * English translations for Error Definitions management
 */
const errorDefinitions = {
  name: 'Error Definitions',
  title: 'Error Definitions',
  subtitle: 'Manage error codes, translations, and severity levels',
  empty: 'No error definitions found',

  // Actions
  actions: {
    create: 'Add Definition',
    edit: 'Edit',
    delete: 'Delete',
  },

  // Fields
  fields: {
    errorCode: 'Error Code',
    severity: 'Severity',
    category: 'Category',
    nature: 'Nature',
    title: 'Title',
    description: 'Description',
    recommendation: 'Recommendation',
    translations: 'Translations',
    languages: 'languages',
    language: 'Language',
    actions: 'Actions',
    createdAt: 'Created',
    updatedAt: 'Updated',
    conditions: 'Conditions',
    metadataKey: 'Metadata key',
    metadataValue: 'Value',
    operator: 'Operator',
    conditionActive: 'Active',
  },

  // Condition count chip (pluralized)
  conditionCount: '%{smart_count} condition |||| %{smart_count} conditions',

  // Condition operators
  operator: {
    equals: 'Equals',
  },

  // Filters
  filters: {
    search: 'Search by code or title',
    severity: 'Severity',
    category: 'Category',
    all: 'All',
  },

  // Severity levels
  severity: {
    critical: 'Critical',
    info: 'Info',
    warning: 'Warning',
  },

  // Nature types
  nature: {
    error: 'Error',
    operational: 'Operational',
    informational: 'Informational',
  },

  // Categories (must match backend ErrorCategory enum)
  category: {
    encoder: 'Encoder',
    mechanical: 'Mechanical',
    card: 'Card',
    room: 'Room',
    network: 'Network',
    system: 'System',
    pms: 'Reservation system',
    locks: 'Locks',
    qr: 'QR Code',
    payments: 'Payments',
    identification: 'Identification',
  },

  // Status
  status: {
    active: 'Active',
    inactive: 'Inactive',
  },

  // Dialog
  dialog: {
    createTitle: 'Create Error Definition',
    editTitle: 'Edit Error Definition',
    basicInfo: 'Basic Information',
    translations: 'Translations',
    addTranslation: 'Add Translation',
    conditions: 'Conditions',
    addCondition: 'Add Condition',
    noConditions: 'No conditions. This definition applies to any event with this error code.',
    errorCodeHelp: 'Unique code in UPPERCASE (e.g., MECH_JAM)',
    titleHelp: 'Short, descriptive title for the error',
    descriptionHelp: 'Detailed explanation of what this error means',
    recommendationHelp: 'Recommended action for operators to resolve this error',
  },

  // Help texts for popovers
  help: {
    basicInfo: 'Define the error code and classification. The error code must be unique and in uppercase format.',
    severity: 'Critical requires immediate attention. Warning flags a situation worth reviewing but not urgent. Info requires no action.',
    category: 'Categorize the error to help with filtering and identification of the problem type.',
    nature: 'Determines if this counts as a real error in KPIs. "Operational" events (e.g. card hopper empty) are expected states, not failures.',
    translations: 'Provide translations for each language. English is required as the default language.',
    conditions: 'Restrict when this definition applies based on event metadata. When you add several, all must match (logical AND). With no conditions, the definition applies to any event with this error code.',
  },

  // Placeholders
  placeholders: {
    title: 'e.g., Paper jam',
    description: 'e.g., Paper is stuck in the dispenser mechanism',
    recommendation: 'e.g., Open the cover and remove the jammed paper',
    metadataKey: 'e.g., reason',
    metadataValue: 'e.g., DocumentNotValid',
  },

  // Validation
  validation: {
    errorCodeRequired: 'Error code is required',
    errorCodeFormat: 'Error code must be uppercase letters, numbers, and underscores',
    titleRequired: 'At least one title is required',
    englishRequired: 'English translation with title is required',
    conditionIncomplete: 'Each condition must have a key and a value',
  },

  // Notifications
  notifications: {
    created: 'Error definition created successfully',
    updated: 'Error definition updated successfully',
    deleted: 'Error definition deleted successfully',
  },

  // Errors
  errors: {
    loadFailed: 'Failed to load error definitions',
    saveFailed: 'Failed to save error definition',
    deleteFailed: 'Failed to delete error definition',
    noPermission: 'You do not have permission to manage error definitions',
  },
};

export default errorDefinitions;
